import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { bindActionCreators } from 'redux';
import { AppActionCreators } from '../actions';
import { LegalDocumentCard } from './LegalDocumentCard';
import {RouteUrls} from '../configs/routeUrls';
import isEqual from 'lodash.isequal';

class LegalDocumentContainer extends Component {
	componentDidMount() {
		if (this.props.legalDocument) {
			this.props.setBreadcrumbs([
				{
					url: RouteUrls.App.legalDocument,
					displayName: this.props.legalDocument.displayText
				}
			]);
		}
	}

	componentDidUpdate(prevProps) {
		if (!isEqual(prevProps.legalDocument, this.props.legalDocument)) {
			if (this.props.legalDocument) {
				this.props.setBreadcrumbs([
					{
						url: RouteUrls.App.legalDocument,
						displayName: this.props.legalDocument.displayText
					}
				]);
			}
		}
	}

	componentWillUnmount() {
		this.props.unloadApp();
	}

	render() {
		const { legalDocument } = this.props;
		return <LegalDocumentCard {...legalDocument} />;
	}
}

const mapStateToProps = (state, ownProps) => {
	return {
		legalDocument: state.app.legalDocument
	};
};

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		...bindActionCreators(AppActionCreators, dispatch),
		...{ goTo: (url) => dispatch(push(url)) }
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(LegalDocumentContainer);
